import React from "react";
import { Label } from "./label";
import Input from "./input";

export const FormInput = React.forwardRef(
  (
    {
      label,
      id,
      name,
      type = "text",
      error,
      className,
      containerClassName,
      register,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`space-y-2 ${containerClassName || ""}`}>
        {label && (
          <Label htmlFor={id || name} className="text-sm font-semibold">
            {label}
          </Label>
        )}
        <Input
          id={id || name}
          name={name}
          type={type}
          ref={ref}
          className={`w-full ${error ? "border-negative" : ""} ${
            className || ""
          }`}
          {...(register ? register(name) : {})}
          {...props}
        />
        {error && (
          <p className="text-sm text-negative">
            {typeof error === "string" ? error : error.message}
          </p>
        )}
      </div>
    );
  }
);

FormInput.displayName = "FormInput";

export default FormInput;
